import React, { useState, useRef } from 'react';
    import SafeIcon from '../common/SafeIcon';
    import { FiUploadCloud, FiCheckCircle } from 'react-icons/fi';

    const ImageUploader = ({ onUpload }) => {
      const [isDragging, setIsDragging] = useState(false);
      const [uploadSuccess, setUploadSuccess] = useState(false);
      const fileInputRef = useRef(null);

      const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") setIsDragging(true);
        else if (e.type === "dragleave") setIsDragging(false);
      };

      const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          onUpload(Array.from(e.dataTransfer.files));
          triggerSuccess();
          e.dataTransfer.clearData();
        }
      };

      const triggerSuccess = () => {
        setUploadSuccess(true);
        setTimeout(() => setUploadSuccess(false), 2500);
      };

      return (
        <div className="relative group" onDragEnter={handleDrag}>
          <div onClick={() => fileInputRef.current.click()} className={`w-full p-14 border-2 border-dashed rounded-3xl transition-all duration-500 flex flex-col items-center justify-center text-center cursor-pointer ${uploadSuccess ? 'border-green-500 bg-green-50' : 'border-gray-200 bg-gray-50/50 hover:bg-white hover:border-blue-400 hover:shadow-xl'}`}>
            <input ref={fileInputRef} type="file" multiple accept="image/jpeg,image/png,image/jpg" className="hidden" onChange={(e) => { if (e.target.files.length > 0) { onUpload(Array.from(e.target.files)); triggerSuccess(); } }} />
            <div className={`mb-6 p-5 rounded-full transition-all duration-500 ${uploadSuccess ? 'bg-green-100' : 'bg-blue-50 group-hover:scale-110'}`}>
              {uploadSuccess ? <SafeIcon icon={FiCheckCircle} className="text-5xl text-green-600 animate-bounce" /> : <SafeIcon icon={FiUploadCloud} className="text-5xl text-blue-500" />}
            </div>
            <h3 className="text-2xl font-black text-gray-800 mb-3">{uploadSuccess ? 'Images Added Successfully!' : 'Click or Drag Images'}</h3>
            <p className="text-lg text-gray-500 max-w-sm font-medium leading-relaxed text-center">Upload your JPG or PNG files to convert them into a professional PDF document.</p>
            <div className="mt-8 flex items-center gap-4">
              <span className="text-xs font-black text-gray-400 bg-white px-3 py-1.5 border rounded-lg shadow-sm">JPG</span>
              <span className="text-xs font-black text-gray-400 bg-white px-3 py-1.5 border rounded-lg shadow-sm">PNG</span>
            </div>
          </div>
          {isDragging && (
            <div className="absolute inset-0 z-50 bg-blue-600/95 rounded-3xl flex flex-col items-center justify-center border-4 border-blue-400 border-dashed animate-in fade-in zoom-in duration-200" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}>
              <div className="bg-white p-8 rounded-full shadow-2xl mb-6 animate-bounce">
                <SafeIcon icon={FiUploadCloud} className="text-6xl text-blue-600" />
              </div>
              <h2 className="text-3xl font-black text-white mb-2">Drop Images Now</h2>
              <p className="text-xl text-blue-100 font-bold">Release to start processing</p>
            </div>
          )}
        </div>
      );
    };

    export default ImageUploader;